import _BaseAPIService from "./_BaseAPIService";

  const apiService = _BaseAPIService.instance;
const FooterService = {
  getList: async () => {
    const response = await apiService.get("/footer-info-section");
    return response.data;
  },

  // getById: async (id) => {
  //   const response = await apiService.get(`/footer-info-section/${id}`);
  //   return response.data;
  // },
    
}

export default FooterService
